import React from 'react';
import { makeStyles } from '../../../theme';
import cx from 'classnames';
import Box, { VERTICAL } from '../box';
import ProgressComp from '../../progress';
import Text from '../../text';

const commonStyles = makeStyles(
	() => ({
		centered: {
			width: '100%',
			height:'100%',
			alignItems:"center",
			justifyContent:"center"
		}
	})
);

export default function Interstitial({children}) {
	const commonClasses = commonStyles();
	return (
		<Box type={VERTICAL} className={cx(commonClasses.centered)}>
			{children}
		</Box>
	);
}

export function Progress({message}) {
	return (
		<Interstitial>
			<ProgressComp />
			{message && <Text variant="h6">{message}</Text>}
		</Interstitial>
	);
}

export function Failure({message}) {
	return (
		<Interstitial>
			{message && <Text variant="h6">{message}</Text>}
		</Interstitial>
	);
}